import { getClientFullname } from "./client"
import { DialogBadge } from "../../models/Dialogs/dialog"

export const sortDialogBadgeByClientName = (firstDialogBadge: DialogBadge, secondDialogBadge: DialogBadge) => {
    const firstFullName = getClientFullname(firstDialogBadge.Client).toLowerCase()
    const secondFullName = getClientFullname(secondDialogBadge.Client).toLowerCase()

    if (firstFullName < secondFullName) {
        return -1
    }
    if (firstFullName > secondFullName) {
        return 1
    }

    return 0
}
